<template>
  <div class="ViewPromo" ref="container">
    <view-top :title="title" :desc="desc" :id="id"></view-top>
    <view-how-cards class="ViewPromo__section"></view-how-cards>
    <view-promo-products
      :id="id"
      :productId="productId"
      :showAll="true"
      class="ViewPromo__section"
    ></view-promo-products>
    <div class="ViewDieselInfo ViewPromo__section">
      <div class="ViewDieselInfo__content">
        <h2 class="ViewDieselInfo__title">{{ name }}</h2>
        <div class="ViewDieselInfo__inn">ИНН {{ inn }}</div>
        <div class="ViewDieselInfo__text app-typography">
          <p>
            <strong>
              ООО « Энергия» является официальным дистрибьютором ООО
              «Газпромнефть-Битумные материалы». Компания осуществляет
              деятельность по реализации светлых и темных нефтепродуктов во всех
              регионах Российской Федерации и в Азиатско-Тихоокеанском
              регионе.</strong
            >
          </p>
          <p>
            Складская инфраструктура по приему, хранению и наливу в автоцистерны
            светлых и темных нефтепродуктов насчитывает 17 нефтебаз. Собственный
            логистический центр позволяет круглосуточно и бесперебойно
            обеспечивать нефтепродуктами своих потребителей. ООО «Энергия»
            приглашает к сотрудничеству на долгосрочной основе и на выгодных
            условиях.
          </p>
        </div>
      </div>
    </div>
    <view-oil-scheme class="ViewPromo__section"></view-oil-scheme>
    <view-seo-columns title="Битум оптом" class="ViewPromo__section">
      <template #col1>
        <h3>Битум БНД 50/70</h3>
        <p>
          Поставка битума БНД 50/70 от ведущего российского производителя - ООО
          “Газпромнефть-Битумные материалы” по всей территории России. Относится
          к категории вязких битумов улучшенной модификации и характеризуется
          высокими характеристиками вязкости, термостабильности и прочности.
          Битум БНД 50/70 защищен от деформации и трещинообразования, устойчив к
          перепадам температур, и используется в первую очередь для дорожного
          строительства. Другие сферы применения битума БНД 50/70 - это пропитка
          обрабатываемой площади и строительство взлетных полос.
        </p>
      </template>
      <template #col2>
        <h3>Битум БНД 60/90</h3>
        <p>
          ООО “Энергия” является поставщиком битума БНД 60/90 от ООО
          “Газпромнефть-Битумные материалы”. Этот вид битума обладает повышенной
          сцепляемостью с каменными материалами и высокой степенью пластичности
          даже при отрицательных температурах. Битум БНД 50/70 применяется для
          пропитки щебеночных покрытий, при строительстве и ремонте дорог, а
          также для гидроизоляции и создании горячих асфальтобетонных и
          битумоминеральных смесей. Битум БНД 60/90 обладает отличной адгезией и
          высокой проникающей способностью, стойкостью к влаге, тепло- и
          морозостойкостью.
        </p>
      </template>
      <template #col3>
        <h3>Битум БНД 70/100</h3>
        <p>
          Реализация дорожного битума категории вязких битумов улучшенной
          модификации. Производство - ООО “Газпромнефть-Битумные материалы”.
          Битум БНД 70/100 изготавливается посредством окисления гудрона и
          меняет свои свойства в зависимости от условий. Основное применение
          битума БНД 70/100 - изготовление асфальтовой смеси для строительства
          дорог при температуре не менее 5°С. С одинаковой эффективностью
          применяется как при строительстве, так и при ремонте
          дорог.Используется также как основа при производстве модифицированных
          битумов, битумных эмульсий, дорожных мастик, праймеров и герметиков.
        </p>
      </template>
    </view-seo-columns>
    <view-safe-advantages class="ViewPromo__section"></view-safe-advantages>
    <view-seo-text
      title="Купить битум оптом в Москве и Московской области"
      class="ViewPromo__section"
    >
      <template #text>
        <p>
          Битум - универсальный материал, который благодаря своим отличным
          гидрофодным и адгезионным характеристикам находит широкое применение в
          дорожном строительстве и ремонте. Производится путем обработки
          продуктов нефтеперерабатывающей промышленности с добавлением различных
          соединений и растворителей.
        </p>
        <p>
          ООО “Энергия” осуществляет поставки битума БНД 50/70, битума БНД 60/90
          и битума БНД 70/100 по всей территории Российской Федерации (включая
          новые регионы) собственным транспортом, а также в Китай, Индию и ЮАР
          по железной дороге.
        </p>
        <p>
          Цифры дроби битума БНД - 50/70, 60/90, 70/100 указывают на допустимые
          для марки пределы показателей глубины проникания стандартной иглы при
          25°С и характеризуют вязкость битума. Вязкие битумы используют для
          приготовления асфальтобетонных смесей и для поверхностной обработки и
          пропитки. А также для изготовления жидких битумов, которые применяются
          для приготовления холодного асфальтобетона, смешения на дороге, и т.д.
        </p>

        <p>
          Компания предлагает битум с доставкой, автопарк компании насчитывает
          более 20 современных битумовозов, которые используются при заказе
          битумных материалов от ООО “Энергия” на маркетплейсе OPEN OIL MARKET.
          Компания объединяет 17 нефтебаз и складскую инфраструктуру по
          реализации нефтепродуктов на территории России.
        </p>
        <p>
          Высокое качество битумов БНД 50/70, БНД 60/90 и БНД 70/100
          гарантировано ведущим производителем России - ООО
          “Газпромнефть-Битумные материалы” с развитой сетью производственных
          мощностей в Москве, Омске, Рязани, Смоленской и Ростовской областях.
          Каждая третья дорога в Российской Федерации построена с битумом
          “Газпром нефти”.
        </p>
      </template>
    </view-seo-text>
    <view-advantages class="ViewPromo__section"></view-advantages>
    <view-landing-buttons
      :buttons="buttons"
      class="ViewPromo__section"
    ></view-landing-buttons>
  </div>
</template>

<script>
export default {
  name: 'ViewPromo',
  inject: ['responsive'],
  components: {
    ViewPromoProducts: () =>
      import('@/pages/static/components/ViewPromoProducts.vue'),
    ViewSafeAdvantages: () =>
      import('@/pages/static/components/ViewSafeAdvantages'),
    ViewTop: () => import('@/pages/static/components/ViewTop'),
    ViewAdvantages: () => import('@/pages/static/components/ViewAdvantages'),
    ViewOilScheme: () => import('@/pages/static/components/ViewOilScheme'),
    ViewLandingButtons: () =>
      import('@/pages/static/components/ViewLandingButtons'),
    ViewHowCards: () => import('@/pages/static/components/ViewHowCards'),
    ViewSeoText: () => import('@/pages/static/components/ViewSeoText'),
    ViewSeoColumns: () => import('@/pages/static/components/ViewSeoColumns'),
  },
  data: () => ({
    title: 'Купить Битум Оптом онлайн от поставщика ООО ЭНЕРГИЯ',
    desc: 'на платформе OPEN OIL MARKET',
    id: 964,
    productId: 2130,
    name: 'ООО «Энергия»',
    inn: '7708400739',
    buttons: [
      {
        name: 'Купить битум',
        link: '/catalog/bitumnye-materialy/page/1',
      },
    ],
  }),
};
</script>
